<template>
  <BaseSimpleLayout class="ship-detail">
    <template #title>出荷情報詳細</template>
    <template v-if="loadingFlag" #button-area>
      <ScreenPermissionGate code="SHIPPING-BTN_REMAND">
        <el-button
          v-if="status !== 3 && !isLinkedDevice"
          type="danger"
          size="large"
          @click="displayRemandDialog"
        >
          差し戻し
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_DEVICE_REGISTER">
        <el-button
          v-if="displayRegisterButton()"
          type="success"
          size="large"
          @click="displayDeviceLinkDialog"
        >
          端末登録
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_DEVICE_BULK_REGISTER">
        <el-button
          v-if="status !== 1 && !isLinkedDevice && type === 3"
          type="success"
          size="large"
          @click="displayBulkLinkDialog"
        >
          端末一括登録
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_DEVICE_SINGLE_REGISTER">
        <el-button
          v-if="status === 2 && !reachLinkedDevice && type === 3"
          type="success"
          size="large"
          @click="displayDeviceLinkDialog"
        >
          個別端末登録
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_UNLINK">
        <el-button
          v-if="status === 2 && isLinkedDevice && type !== 2"
          type="warning"
          size="large"
          @click="displayUnLinkDialog"
        >
          リンク解除
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_UNLINK_SINGLE">
        <el-button
          v-if="status === 2 && isLinkedDevice && type === 3"
          type="warning"
          size="large"
          @click="deviceUnlinkDialog = true"
        >
          個別リンク解除
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_START_PREPARATION">
        <el-button
          v-if="status === 1"
          type="primary"
          size="large"
          @click="displayReadyDialog"
        >
          準備開始
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_CANCEL_PREPARATION">
        <el-button
          v-if="status === 2 && !isLinkedDevice"
          type="warning"
          size="large"
          @click="displayUnreadyDialog"
        >
          準備キャンセル
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_CHECKLIST">
        <el-button
          v-if="displayShipComplete()"
          type="danger"
          size="large"
          @click="router.push('/ship/check/' + shipId)"
        >
          チェックリスト
        </el-button>
      </ScreenPermissionGate>

      <el-button
        v-if="
          businessType !== 2 && status === 2 && (isLinkedDevice || !mccsShip)
        "
        type="success"
        size="large"
        @click="router.push(`/ship/label/${shipId}`)"
      >
        ラベル印刷
      </el-button>
      <el-button
        v-if="
          businessType === 2 && status === 2 && (isLinkedDevice || !mccsShip)
        "
        type="success"
        size="large"
        @click="router.push(`/ship/carsecqr`)"
      >
        QR印刷
      </el-button>
      <el-button size="large" @click="router.push('/ship/note/' + shipId)">
        納品書
      </el-button>
      <ScreenPermissionGate code="SHIPPING-BTN_COMPLETE_WORK">
        <el-button
          v-if="displayShipComplete()"
          type="primary"
          size="large"
          @click="shipCompleteDialog = true"
        >
          作業完了
        </el-button>
      </ScreenPermissionGate>
      <ScreenPermissionGate code="SHIPPING-BTN_APPROVE_SHIPMENT">
        <el-button
          v-if="status === 3 && isApproved === false"
          type="danger"
          size="large"
          @click="shipApproveDialog = true"
        >
          出荷承認
        </el-button>
      </ScreenPermissionGate>
      <el-button size="large" type="info" @click="router.push('/ship')">
        戻る
      </el-button>
    </template>
    <template v-if="loadingFlag" #main>
      <div class="ship-detail-table-area">
        <div class="ship-detail-table-line">
          <div class="table-title">受注情報</div>
          <BaseDataTable
            :table-data="acceptData"
            table-size="small"
            :label-width="125"
          />
          <div class="table-title">発送単品情報</div>
          <el-table
            :data="itemData"
            stripe
            border
            style="width: 500px; margin: 0px auto 30px"
            class="ship-detail-product"
            empty-text="製品が存在しません"
            size="small"
          >
            <el-table-column
              prop="name"
              label="製品名"
              align="center"
              class-name="unit-master-product-details-name"
            />
            <el-table-column
              prop="qty"
              label="個数"
              width="55px"
              align="center"
              class-name="unit-master-product-details-qty"
            />
          </el-table>
        </div>
        <div v-if="type !== 2" class="ship-detail-table-line">
          <div v-if="type === 1" class="table-title">取付車両情報</div>
          <BaseDataTable
            v-if="type === 1"
            :table-data="carData"
            table-size="small"
            :label-width="120"
          />
          <div class="table-title">端末情報</div>
          <el-table
            v-if="type !== 2 && mccsShip"
            :data="deviceData"
            stripe
            border
            style="width: 640px; margin: 0px auto 30px"
            class="ship-detail-device"
            empty-text="端末が存在しません"
            size="small"
          >
            <el-table-column label="シリアル番号" align="center">
              <template #default="scope">
                <router-link
                  :to="
                    orderCompanyId === 459
                      ? `/carSecurity/device/detail/${scope.row.id}`
                      : `/device/${scope.row.id}/detail`
                  "
                >
                  {{ scope.row.deviceSerialCode }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column label="SIMキャリア" align="center">
              <template #default="scope">
                {{ shipSimCarrierLabel(scope.row.simCarrier) }}
              </template>
            </el-table-column>
            <el-table-column prop="simNumber" label="sim番号" align="center" />
            <el-table-column label="種類" align="center" width="50px">
              <template #default="scope">{{
                omitHandlingType[scope.row.handlingType]
              }}</template>
            </el-table-column>
          </el-table>
          <div v-else class="not-mccs-ship">端末出荷無し</div>
        </div>
        <div class="ship-detail-table-line">
          <div class="table-title">発送先情報</div>
          <BaseDataTable
            :table-data="shipmentData"
            table-size="small"
            :label-width="80"
          />
          <div class="table-title">受注備考</div>
          <el-input
            v-model="acceptNote"
            style="margin-bottom: 15px"
            type="textarea"
            placeholder=""
            autosize
            :disabled="true"
          />
          <div class="table-title">
            出荷備考
            <ScreenPermissionGate code="SHIPPING-BTN_SHIP_NOTE_UPDATE">
              <el-button
                v-if="noteEditDisabled"
                class="ship-detail-title-side-button"
                type="info"
                size="small"
                @click="noteEditDisabled = false"
              >
                編集
              </el-button>
            </ScreenPermissionGate>
            <el-button
              v-if="!noteEditDisabled"
              class="ship-detail-title-side-button"
              type="primary"
              size="small"
              @click="updateNote()"
            >
              更新
            </el-button>
          </div>
          <el-input
            v-model="shipNote"
            type="textarea"
            :rows="7"
            placeholder=""
            :disabled="noteEditDisabled"
          />
        </div>
        <div class="ship-detail-table-line">
          <div class="table-title">更新情報</div>
          <BaseDataTable
            :table-data="remarkData"
            table-size="small"
            :label-width="110"
          />
          <div class="table-title">
            送り状
            <ScreenPermissionGate code="SHIPPING-BTN_EDIT">
              <el-dropdown
                v-if="invoiceEditDisabled"
                class="ship-detail-title-side-button create-invoice-button"
                @command="handleCreateInvoice"
              >
                <el-button type="primary" size="small">
                  作成
                  <el-icon class="el-icon--right"><ArrowDown /></el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="yamato">
                      <div class="invoice-option-logo">
                        <img
                          src="@/assets/yamato.png"
                          alt="Yamato"
                          height="24"
                        />
                      </div>
                      <span>ヤマト作成</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="sagawa" disabled>
                      <div class="invoice-option-logo">
                        <img
                          src="@/assets/sagawa.png"
                          alt="Sagawa"
                          height="20"
                        />
                      </div>
                      <span>佐川作成</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <el-button
                v-if="invoiceEditDisabled"
                class="ship-detail-title-side-button"
                type="info"
                size="small"
                @click="invoiceEditDisabled = false"
              >
                編集
              </el-button>
            </ScreenPermissionGate>
            <el-button
              v-if="!invoiceEditDisabled"
              class="ship-detail-title-side-button"
              type="primary"
              size="small"
              @click="updateInvoice(invoiceFormRef)"
            >
              更新
            </el-button>
            <el-button
              v-if="!invoiceEditDisabled"
              class="ship-detail-title-side-button"
              type="info"
              size="small"
              @click="cancelInvoiceEdit()"
            >
              キャンセル
            </el-button>
            <el-button
              v-if="invoiceEditDisabled"
              class="ship-detail-title-side-button"
              type="info"
              size="small"
              @click="getShipDetail()"
            >
              リロード
            </el-button>
          </div>
          <el-form
            ref="invoiceFormRef"
            :model="invoiceForm"
            :rules="invoiceRules"
            label-width="0px"
          >
            <el-form-item
              label=""
              prop="invoiceCode"
              class="invoice-input-with-select"
            >
              <el-input
                v-model="invoiceForm.invoiceCode"
                :disabled="invoiceEditDisabled"
                placeholder="送り状番号を入力"
                clearable
                :maxlength="INVOICE_CODE_MAX_LENGTH"
                class="invoice-input-field"
              >
                <template v-if="!invoiceEditDisabled" #append>
                  <div
                    class="invoice-supplier-icon-wrapper"
                    :class="{
                      'is-none':
                        invoiceForm.invoiceSupplier === INVOICE_SUPPLIER.NONE
                    }"
                  >
                    <img
                      v-if="
                        invoiceForm.invoiceSupplier === INVOICE_SUPPLIER.YAMATO
                      "
                      src="@/assets/yamato.png"
                      alt="Yamato"
                      height="22"
                      class="current-supplier-icon"
                    />
                    <img
                      v-else-if="
                        invoiceForm.invoiceSupplier === INVOICE_SUPPLIER.SAGAWA
                      "
                      src="@/assets/sagawa.png"
                      alt="Sagawa"
                      height="18"
                      class="current-supplier-icon"
                    />
                    <el-select
                      v-model="invoiceForm.invoiceSupplier"
                      placeholder=""
                      :disabled="invoiceEditDisabled"
                      class="invoice-supplier-select-icon"
                      @change="onInvoiceSupplierChange"
                    >
                      <el-option
                        :value="INVOICE_SUPPLIER.YAMATO"
                        label="ヤマト運輸"
                      >
                        <div class="select-option-content">
                          <img
                            src="@/assets/yamato.png"
                            alt="Yamato"
                            height="18"
                          />
                          <span>ヤマト運輸</span>
                        </div>
                      </el-option>
                      <el-option
                        :value="INVOICE_SUPPLIER.SAGAWA"
                        label="佐川急便"
                      >
                        <div class="select-option-content">
                          <img
                            src="@/assets/sagawa.png"
                            alt="Sagawa"
                            height="14"
                          />
                          <span>佐川急便</span>
                        </div>
                      </el-option>
                      <el-option :value="INVOICE_SUPPLIER.NONE" label="なし">
                        <div class="select-option-content">
                          <span>設定なし</span>
                        </div>
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="table-title">出荷時入力情報</div>
          <BaseDataTable
            :table-data="shipInputData"
            table-size="small"
            :label-width="95"
          />
        </div>
      </div>
      <el-dialog v-model="isDisplayDialog" :title="dialogTitle" width="400px">
        <span>
          <b>{{ dialogMessage }}</b>
        </span>
        <template #footer>
          <el-button size="large" @click="isDisplayDialog = false">
            キャンセル
          </el-button>
          <el-button size="large" type="primary" @click="runOperate">
            実行
          </el-button>
        </template>
      </el-dialog>
      <el-dialog
        v-model="shipCompleteDialog"
        title="作業完了登録"
        width="450px"
        @close="handleCompleteDialogClose"
      >
        <el-form
          ref="completeFormRef"
          :model="completeForm"
          :rules="completeRules"
          label-width="170px"
        >
          <el-form-item label="出荷日" prop="shipDate">
            <el-date-picker
              v-model="completeForm.shipDate"
              type="date"
              placeholder="日付を選択"
              style="width: 150px"
              format="YYYY-MM-DD"
              value-format="x"
              :disabled="completeConfirmMode"
            />
          </el-form-item>
          <el-form-item label="着日" prop="receiptDate">
            <el-date-picker
              v-model="completeForm.receiptDate"
              type="date"
              placeholder="日付を選択"
              style="width: 150px"
              format="YYYY-MM-DD"
              value-format="x"
              :disabled="completeConfirmMode"
            />
          </el-form-item>
          <el-form-item
            label="送り状番号"
            prop="invoiceCode"
            :required="isInvoiceCodeRequired(completeForm.invoiceSupplier)"
          >
            <el-input
              v-model="completeForm.invoiceCode"
              placeholder="送り状番号を入力"
              :disabled="completeConfirmMode"
              :maxlength="INVOICE_CODE_MAX_LENGTH"
              style="width: 150px"
              class="complete-invoice-input"
            />
          </el-form-item>
          <el-form-item required label="配送業者" prop="invoiceSupplier">
            <el-select
              v-model="completeForm.invoiceSupplier"
              placeholder="配送業者を選択"
              :disabled="completeConfirmMode"
              style="width: 150px"
              class="complete-supplier-select"
              @change="onCompleteSupplierChange"
            >
              <template #prefix>
                <img
                  v-if="
                    completeForm.invoiceSupplier === INVOICE_SUPPLIER.YAMATO
                  "
                  src="@/assets/yamato.png"
                  alt="Yamato"
                  height="20"
                  class="select-prefix-supplier-icon"
                />
                <img
                  v-else-if="
                    completeForm.invoiceSupplier === INVOICE_SUPPLIER.SAGAWA
                  "
                  src="@/assets/sagawa.png"
                  alt="Sagawa"
                  height="16"
                  class="select-prefix-supplier-icon"
                />
              </template>
              <el-option :value="INVOICE_SUPPLIER.YAMATO" label="ヤマト運輸">
                <div class="select-option-content">
                  <img src="@/assets/yamato.png" alt="Yamato" height="18" />
                  <span>ヤマト運輸</span>
                </div>
              </el-option>
              <el-option :value="INVOICE_SUPPLIER.SAGAWA" label="佐川急便">
                <div class="select-option-content">
                  <img src="@/assets/sagawa.png" alt="Sagawa" height="14" />
                  <span>佐川急便</span>
                </div>
              </el-option>
              <el-option :value="INVOICE_SUPPLIER.NONE" label="設定なし">
                <div class="select-option-content">
                  <span>設定なし</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-if="completeConfirmMode" #footer>
          <el-button size="large" @click="handleCompleteDialogClose">
            戻る
          </el-button>
          <el-button size="large" type="primary" @click="submitComplete">
            登録
          </el-button>
        </template>
        <template v-else #footer>
          <el-button size="large" @click="shipCompleteDialog = false">
            キャンセル
          </el-button>
          <el-button
            size="large"
            type="primary"
            @click="completeShip(completeFormRef)"
          >
            確認
          </el-button>
        </template>
      </el-dialog>
      <el-dialog v-model="shipApproveDialog" title="出荷承認" width="450px">
        <span>
          <b>出荷承認しますか？</b>
        </span>
        <template #footer>
          <el-button size="large" type="primary" @click="submitApprove(true)">
            承認
          </el-button>
          <el-button size="large" type="danger" @click="submitApprove(false)">
            却下
          </el-button>
          <el-button size="large" @click="shipApproveDialog = false">
            キャンセル
          </el-button>
        </template>
      </el-dialog>
      <YamatoInvoiceDialog
        v-model="yamatoDialog"
        :initial-data="yamatoInitialData"
      />
      <el-dialog
        v-model="deviceLinkDialog"
        title="リンク端末登録"
        width="400px"
      >
        <el-form :model="deviceForm" label-width="150px">
          <el-form-item label="端末シリアル番号" prop="shipDate">
            <el-select v-model="deviceForm.id" filterable placeholder="選択">
              <el-option
                v-for="item in deviceList"
                :key="item.id"
                :label="item.serialCode"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button size="large" @click="deviceLinkDialog = false">
            キャンセル
          </el-button>
          <el-button size="large" type="primary" @click="linkDevice()">
            登録
          </el-button>
        </template>
      </el-dialog>
      <el-dialog
        v-model="deviceUnlinkDialog"
        title="リンク端末解除"
        width="400px"
      >
        <el-form :model="unlinkDeviceForm" label-width="150px">
          <el-form-item label="端末シリアル番号" prop="shipDate">
            <el-select
              v-model="unlinkDeviceForm.id"
              filterable
              placeholder="選択"
            >
              <el-option
                v-for="item in linkDeviceList"
                :key="item.id"
                :label="item.deviceSerialCode"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button size="large" @click="deviceUnlinkDialog = false">
            キャンセル
          </el-button>
          <el-button size="large" type="primary" @click="unlinkDevice()">
            実行
          </el-button>
        </template>
      </el-dialog>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import { error } from '@/libs/notification';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import BaseDataTable from '@/components/BaseDataTable.vue';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import YamatoInvoiceDialog from './components/YamatoInvoiceDialog.vue';
  import {
    createAcceptTableData,
    createCarTableData,
    createShipmentTableData,
    createRemarkTableData,
    createShipInputTableData,
    getPrintName,
    INVOICE_SUPPLIER,
    INVOICE_CODE_MAX_LENGTH,
    isInvoiceCodeRequired,
    invoiceCodeForSupplier,
    isValidInvoiceCodeFormat,
    shipSimCarrierLabel
  } from '@/libs/ship';
  import {
    ShipDetailDataState,
    ShipShipLinkDeviceDataState,
    ShipAcceptDetailState,
    ShipDetailData
  } from '@/types/ship';
  import { DevicesDataState } from '@/types/device';
  import { getHarnessByDeviceType } from '@/libs/device';
  import { DetailTableData } from '@/types/common';
  import { ElLoading } from 'element-plus';
  import type { FormInstance, FormItemRule, FormRules } from 'element-plus';
  import { ArrowDown } from '@element-plus/icons-vue';
  import { omitHandlingType } from '@/libs/device';
  import { getEnv } from '@/libs/env';
  import type { YamatoInvoiceFormData } from '@/types/yamato';

  const props = defineProps({
    shipId: {
      type: String,
      required: true
    }
  });
  const store = useStore();
  const acceptData = ref<DetailTableData[]>([]);
  const carData = ref<DetailTableData[]>([]);
  const itemData = ref<ShipDetailDataState[]>([]);
  const shipmentData = ref<DetailTableData[]>([]);
  const deviceData = ref<ShipShipLinkDeviceDataState[]>([]);
  const remarkData = ref<DetailTableData[]>([]);
  const shipInputData = ref<DetailTableData[]>([]);
  const status = ref(0);
  const isApproved = ref<boolean>(false);
  const type = ref(1);
  const noteEditDisabled = ref(true);
  const invoiceEditDisabled = ref(true);
  const shipNote = ref('');
  const acceptNote = ref('');
  const isLinkedDevice = ref(true);
  const reachLinkedDevice = ref(true);
  const isDisplayDialog = ref(false);
  const dialogMessage = ref('');
  const dialogTitle = ref('');
  let dialogOperate = '';
  const deviceLinkDialog = ref(false);
  const deviceUnlinkDialog = ref(false);
  const shipCompleteDialog = ref(false);
  const shipApproveDialog = ref(false);
  const yamatoDialog = ref(false);
  const businessType = ref(1);
  const deviceType = ref(3);

  const deviceForm = ref({
    id: 0
  });

  const unlinkDeviceForm = ref({
    id: 0
  });

  const invoiceForm = ref({
    invoiceCode: '',
    invoiceSupplier: 1
  });
  const invoiceCode = ref('');
  const invoiceSupplier = ref(INVOICE_SUPPLIER.YAMATO);
  const invoiceFormRef = ref<FormInstance>();

  const completeForm = ref({
    shipDate: 0,
    receiptDate: 0,
    invoiceCode: '',
    invoiceSupplier: INVOICE_SUPPLIER.YAMATO
  });
  const completeFormRef = ref<FormInstance>();

  // --- 送り状番号 validators ---
  /** ヤマト/佐川: 4-4-4。設定なし: 自由入力（DB length のみ） */
  const invoiceCodeErrorMessage = (
    value: string,
    invoiceSupplier: number
  ): string | null => {
    if (isValidInvoiceCodeFormat(value, invoiceSupplier)) return null;
    if ((value?.length ?? 0) > INVOICE_CODE_MAX_LENGTH) {
      return `送り状番号は${INVOICE_CODE_MAX_LENGTH}文字以内で入力してください。`;
    }
    return '送り状番号形式で入力してください。';
  };

  const validateInvoiceForm: FormItemRule['validator'] = (
    _rule,
    value,
    callback
  ) => {
    const err = invoiceCodeErrorMessage(
      value ?? '',
      invoiceForm.value.invoiceSupplier
    );
    err ? callback(new Error(err)) : callback();
  };

  const validateCompleteInvoice: FormItemRule['validator'] = (
    _rule,
    value,
    callback
  ) => {
    const err = invoiceCodeErrorMessage(
      value ?? '',
      completeForm.value.invoiceSupplier
    );
    err ? callback(new Error(err)) : callback();
  };

  const invoiceRules = ref<FormRules>({
    invoiceCode: [{ validator: validateInvoiceForm, trigger: 'change' }]
  });

  /** 作業完了ダイアログ: 必須は従来どおり。設定なしのときのみ送り状番号を任意にする */
  const completeRules = computed<FormRules>(() => ({
    shipDate: [{ required: true, message: '出荷日は必須です。' }],
    receiptDate: [{ required: true, message: '着日は必須です。' }],
    invoiceCode: [
      ...(isInvoiceCodeRequired(completeForm.value.invoiceSupplier)
        ? [
            {
              required: true,
              message: '送り状番号は必須です。',
              trigger: 'blur' as const
            }
          ]
        : []),
      { validator: validateCompleteInvoice, trigger: 'blur' }
    ]
  }));

  /** ユーザーが配送業者を変えた時のみ「発送不要」をセット/クリア（init では呼ばない） */
  const onInvoiceSupplierChange = (supplier: number) => {
    invoiceForm.value.invoiceCode = invoiceCodeForSupplier(
      supplier,
      invoiceForm.value.invoiceCode
    );
    invoiceFormRef.value?.clearValidate(['invoiceCode']);
  };

  const onCompleteSupplierChange = (supplier: number) => {
    completeForm.value.invoiceCode = invoiceCodeForSupplier(
      supplier,
      completeForm.value.invoiceCode
    );
    completeFormRef.value?.clearValidate(['invoiceCode']);
  };

  const yamatoInitialData = ref<Partial<YamatoInvoiceFormData>>({});

  const deviceList = ref<DevicesDataState[]>([]);
  const linkDeviceList = ref<ShipShipLinkDeviceDataState[]>([]);
  let acceptDetails: ShipAcceptDetailState[] = [];
  const loadingFlag = ref(false);
  const mccsShip = ref(true);
  const completeConfirmMode = ref(false);
  const shipDetail = ref<ShipDetailData>();
  let orderCompanyId: number | null = null;

  const getShipDetail = async () => {
    initialize(true);
  };

  const initialize = async (onlyDetail?: boolean) => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    const promises = [
      store.dispatch('ship/fetchDetail', props.shipId),
      store.dispatch('businessTypesMaster/fetch')
    ];
    if (!onlyDetail) {
      promises.push(
        store.dispatch('itemsMaster/fetch'),
        store.dispatch('harnessesMaster/fetch')
      );
    }
    await Promise.all(promises);
    shipDetail.value = store.state.ship.detailData;
    const detailData = store.state.ship.detailData;
    const businessTypeLabels = store.state.businessTypesMaster.replaceData;
    if (!detailData) return router.push('/ship');
    status.value = detailData.status;
    isApproved.value = detailData.isApproved;
    acceptData.value = createAcceptTableData(detailData, businessTypeLabels);
    acceptDetails = detailData.acceptDetails;
    deviceData.value = detailData.devices;
    itemData.value = detailData.details;
    carData.value = createCarTableData(detailData);
    shipmentData.value = createShipmentTableData(detailData);
    remarkData.value = createRemarkTableData(detailData);
    shipInputData.value = createShipInputTableData(detailData);
    businessType.value = detailData.businessType;
    deviceType.value = detailData.deviceType;
    orderCompanyId = detailData.orderCompanyId;
    if (acceptDetails) {
      const mccsData = acceptDetails.filter((detail: ShipAcceptDetailState) => {
        return detail.productType === 1;
      });
      if (mccsData.length === 0) {
        mccsShip.value = false;
      }
    }
    if (detailData.harnessId) {
      let partCode = '-';
      let itemName = '-';
      const item = await getHarnessByDeviceType(
        store.state.harnessesMaster.listData,
        detailData.harnessId,
        detailData.harnessType
      );
      if (item?.itemId) {
        const itemReplaceData = store.state.itemsMaster.replaceData;
        partCode = itemReplaceData[item.itemId].partCode;
        itemName = item.itemName;
      }
      const printName = getPrintName(itemName, detailData);
      carData.value.push({
        label: 'ハーネス品番',
        value: partCode
      });
      carData.value.push({
        label: 'ハーネス名称',
        value: itemName
      });
      carData.value.push({
        label: '適合判定',
        value: detailData.compatibilityResultJudge === 2 ? '〇※' : ''
      });
      carData.value.push({
        label: '印刷資料',
        value: printName
      });
    }
    shipNote.value = detailData.note;
    acceptNote.value = detailData.acceptNote;
    invoiceCode.value = detailData.invoiceCode;
    invoiceSupplier.value = detailData.invoiceSupplier;
    {
      const supplier = detailData.invoiceSupplier ?? INVOICE_SUPPLIER.YAMATO;
      completeForm.value.invoiceSupplier = supplier;
      completeForm.value.invoiceCode = detailData.invoiceCode ?? '';
      invoiceForm.value.invoiceSupplier = supplier;
      invoiceForm.value.invoiceCode = detailData.invoiceCode ?? '';
    }
    type.value = detailData.type;
    isLinkedDevice.value = detailData.devices.length > 0;
    if (type.value === 3) {
      reachLinkedDevice.value =
        detailData.devices.length === itemData.value[0].qty;
    }
    const today = new Date();
    const tommorow = new Date().setDate(today.getDate() + 1);
    completeForm.value.shipDate = today.getTime();
    if (detailData.arrivalDate) {
      completeForm.value.receiptDate = detailData.arrivalDate;
    } else {
      completeForm.value.receiptDate = tommorow;
    }
    if (status.value === 2 && type.value === 3 && isLinkedDevice.value) {
      linkDeviceList.value = detailData.devices;
      unlinkDeviceForm.value.id = detailData.devices[0].id;
    }
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const displayRegisterButton = () => {
    return (
      status.value === 2 &&
      !isLinkedDevice.value &&
      type.value === 1 &&
      mccsShip.value
    );
  };
  const displayShipComplete = () => {
    if (status.value !== 2) return false;
    if (type.value === 1 && isLinkedDevice.value) return true;
    if (type.value === 1 && !mccsShip.value) return true;
    if (type.value === 3 && reachLinkedDevice.value) return true;
    return false;
  };
  const displayReadyDialog = () => {
    dialogOperate = 'preparation';
    dialogTitle.value = '作業準備';
    dialogMessage.value = 'ステータスを 準備中 にしますがよろしいですか？';
    isDisplayDialog.value = true;
  };
  const displayUnreadyDialog = () => {
    dialogOperate = 'unpreparation';
    dialogTitle.value = '準備キャンセル';
    dialogMessage.value = 'ステータスを 依頼 に戻しますがよろしいですか？';
    isDisplayDialog.value = true;
  };
  const displayUnLinkDialog = () => {
    dialogOperate = 'unLink';
    dialogTitle.value = 'リンク解除';
    dialogMessage.value = 'リンクされた端末を解除しますがよろしいですか？';
    isDisplayDialog.value = true;
  };
  const displayBulkLinkDialog = async () => {
    await createDeviceList();
    deviceList.value.sort((a: DevicesDataState, b: DevicesDataState) => {
      if (a.serialCode > b.serialCode) {
        return 1;
      } else {
        return -1;
      }
    });
    dialogOperate = 'bulkLink';
    dialogTitle.value = '端末一括登録';
    dialogMessage.value =
      '登録可能な端末を ' +
      deviceList.value[0].serialCode +
      ' から一括で登録しますがよろしいですか？';
    isDisplayDialog.value = true;
  };
  const displayRemandDialog = () => {
    dialogOperate = 'remand';
    dialogTitle.value = '出荷情報差し戻し';
    dialogMessage.value = '出荷情報を差し戻しますがよろしいですか？';
    isDisplayDialog.value = true;
  };
  const runOperate = async () => {
    isDisplayDialog.value = false;
    if (dialogOperate === 'preparation') {
      await store.dispatch('ship/preparation', props.shipId);
      initialize();
    }
    if (dialogOperate === 'unpreparation') {
      await store.dispatch('ship/unpreparation', props.shipId);
      initialize();
    }
    if (dialogOperate === 'unLink') {
      await store.dispatch('ship/unlinkDevice', props.shipId);
      initialize();
    }
    if (dialogOperate === 'bulkLink') {
      await createDeviceList();
      if (itemData.value[0].qty > deviceList.value.length) {
        error(
          'error',
          '端末数が不足しています。対象の確定端末を追加して再度実行してください。'
        );
      } else {
        const targetDevice = deviceList.value.slice(0, itemData.value[0].qty);
        const deviceIdList = targetDevice.map((data) => data.id);
        await store.dispatch('ship/linkDevice', {
          id: props.shipId,
          devices: deviceIdList
        });
        initialize();
      }
    }
    if (dialogOperate === 'remand') {
      await store.dispatch('ship/remand', props.shipId);
    }
  };
  const completeShip = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate(async (valid) => {
      if (!valid) {
        return;
      }
      completeConfirmMode.value = true;
    });
  };
  const handleCompleteDialogClose = () => {
    completeConfirmMode.value = false;

    const detailData = shipDetail.value;
    if (detailData) {
      const today = new Date();
      const tommorow = new Date().setDate(today.getDate() + 1);
      completeForm.value.shipDate = today.getTime();
      completeForm.value.receiptDate = detailData.arrivalDate || tommorow;
      {
        const supplier = detailData.invoiceSupplier ?? INVOICE_SUPPLIER.YAMATO;
        completeForm.value.invoiceSupplier = supplier;
        completeForm.value.invoiceCode = detailData.invoiceCode ?? '';
      }
    }
    completeFormRef.value?.clearValidate();
  };

  const submitComplete = async () => {
    await store.dispatch('ship/complete', {
      id: props.shipId,
      data: completeForm.value
    });
    shipCompleteDialog.value = false;
    completeConfirmMode.value = false;
    initialize();
    router.push('/ship');
  };
  const submitApprove = async (isApprove: boolean) => {
    await store.dispatch('ship/approve', {
      id: props.shipId,
      data: isApprove
    });
    shipApproveDialog.value = false;
    initialize();
    router.push('/ship');
  };
  const linkDevice = async () => {
    await store.dispatch('ship/linkDevice', {
      id: props.shipId,
      devices: [deviceForm.value.id]
    });
    deviceLinkDialog.value = false;
    initialize();
  };
  const unlinkDevice = async () => {
    await store.dispatch('device/unlink', unlinkDeviceForm.value.id);
    deviceUnlinkDialog.value = false;
    initialize();
  };
  const updateNote = async () => {
    await store.dispatch('ship/patchNote', {
      id: props.shipId,
      note: shipNote.value
    });
    initialize();
    noteEditDisabled.value = true;
  };

  const displayDeviceLinkDialog = async () => {
    await createDeviceList();
    if (deviceList.value.length < 1) {
      error(
        '404',
        '接続可能な端末が存在しません。端末管理画面で端末を追加してください。'
      );
    } else {
      deviceLinkDialog.value = true;
    }
  };
  const createDeviceList = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await store.dispatch('devices/fetchReady');
    deviceList.value = store.state.devices.readyListData.filter(
      (data: DevicesDataState) => {
        return (
          data.orderCompanyId === orderCompanyId &&
          data.deviceType === shipDetail.value?.deviceType
        );
      }
    );
    if (deviceList.value.length > 0)
      deviceForm.value.id = deviceList.value[0].id;
    loadingInstance.close();
  };

  /**
   * ヤマト運輸送り状ダイアログを開く
   */
  const openYamatoDialog = () => {
    const detail = shipDetail.value;
    if (!detail) return;

    // 日付フォーマット
    const formatYamatoDate = (timestamp?: number | null): string => {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    };
    const consigneeName = detail.shipTargetName || 'ご担当者';

    // 初期データを準備
    yamatoInitialData.value = {
      // 基本情報
      shipmentNumber: detail.id, // Ship ID
      isCool: '0', // 通常
      serviceType: '0', // 発払い
      shipDate: formatYamatoDate(Date.now()),
      deliveryDate: formatYamatoDate(detail.arrivalDate),
      deliveryTimeZone: '', // 指定なし

      // お届け先情報
      consigneeCode: '', // データなし
      consigneeName: consigneeName,
      consigneeNameKana: '', // データなし
      consigneeTitle: '', // データなし (様/御中など)
      consigneeTelephoneDisplay: detail.shipTel || '',
      consigneeTelephoneExt: '', // 枝番データなし
      consigneeZipCode: detail.shipZip || '',
      consigneeAddress1: detail.shipPrefecture || '',
      consigneeAddress2: detail.shipCity || '',
      consigneeAddress3: detail.shipAddress || '',
      consigneeAddress4: detail.shipAddressSub || '',
      consigneeDepartment1: detail.shipName || '',
      consigneeDepartment2: '', // データなし

      // ご依頼主情報 (GMS固定)
      shipperCode: '03', // 固定値
      shipperTelephoneDisplay: '058-213-2332',
      shipperTelephoneExt: '', // 枝番なし
      shipperZipCode: '5008847',
      shipperAddress1: '岐阜県',
      shipperAddress2: '岐阜市',
      shipperAddress3: '金宝町2-8',
      shipperAddress4: 'マイルストーンズ２F',
      shipperName: 'Global Mobility Service 株式会社',
      shipperNameKana: 'ｸﾞﾛｰﾊﾞﾙ ﾓﾋﾞﾘﾃｨ ｻｰﾋﾞｽ ｶﾌﾞｼｷｶﾞｲｼｬ',

      // 記事
      note: '',

      // センターサービス
      isUsingCenterService: '0', // デフォルト: 使用しない
      consigneeCenterCode: '', // 止置き使用時のみ

      // 発行情報
      packageQty: '', // オプション
      isPrintingLot: '2', // オプション

      // 請求情報 (環境別: Staging / Prod)
      invoiceCode: getEnv() === 'staging' ? '900000000156' : '0582322332',
      invoiceCodeExt: getEnv() === 'staging' ? '999' : '', // オプション
      invoiceFreightNo: '01'
    };

    yamatoDialog.value = true;
  };

  const updateInvoice = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate(async (valid) => {
      if (!valid) return false;
      await store.dispatch('ship/patchInvoice', {
        id: props.shipId,
        invoiceCode: invoiceForm.value.invoiceCode,
        invoiceSupplier: invoiceForm.value.invoiceSupplier
      });
      initialize();
      invoiceEditDisabled.value = true;
    });
  };
  const cancelInvoiceEdit = async () => {
    const supplier = invoiceSupplier.value ?? INVOICE_SUPPLIER.YAMATO;
    invoiceForm.value.invoiceSupplier = supplier;
    invoiceForm.value.invoiceCode = invoiceCode.value ?? '';
    invoiceEditDisabled.value = true;
  };

  /**
   * 送り状作成オプションを処理
   * @param command - 'yamato' または 'sagawa'
   */
  const handleCreateInvoice = (command: string) => {
    if (command === 'yamato') {
      openYamatoDialog();
    } else if (command === 'sagawa') {
      // 佐川作成は未実装のため、何もしない
      // disabled属性で無効化されているため、この分岐には到達しない
    }
  };

  initialize();
</script>
<style lang="scss">
  .ship-detail {
    .main-container {
      width: 98%;
      margin-top: 5px;
    }
    .table-title {
      font-size: 18px;
      font-weight: 600;
      margin: 5px 0;
    }
    .el-table {
      thead {
        th {
          background: #f5f7fa;
        }
      }
    }
    .ship-detail-button-area {
      clear: left;
      margin: 20px 0px;
    }
    .create-invoice-button {
      margin-right: 12px;
      margin-left: 8px;
    }
    .ship-detail-product {
      .cell {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .ship-detail-table-area {
      margin: auto;
      width: 1520px;
      .ship-detail-table-line {
        width: 370px;
        margin-left: 10px;
        float: left;
        margin-top: 10px;
      }
      .el-table {
        .cell {
          font-size: 14px;
          font-weight: 600;
        }
        margin-bottom: 15px !important;
      }
      .BaseDataTable {
        width: 370px;
        margin: 0px auto;
      }
    }
    .ship-detail-title-side-button {
      vertical-align: bottom;
    }
    .el-button {
      font-weight: 600;
    }
    :deep(.el-dropdown-menu__item) {
      display: flex;
      align-items: center;
    }
    .not-mccs-ship {
      font-size: 16px;
      font-weight: 600;
      color: red;
    }
    .el-textarea.is-disabled {
      .el-textarea__inner {
        color: #606266;
        background-color: #fafafa;
      }
    }
    .el-input.is-disabled {
      textarea {
        cursor: default;
      }
    }
    .el-input.is-disabled {
      .el-input__inner {
        color: #606266;
        background-color: #fafafa;
      }
    }
    .el-textarea.is-disabled {
      textarea {
        cursor: default;
      }
    }
    .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
      }
    }
  }
  .invoice-input-with-select,
  .complete-invoice-input {
    max-width: 600px;

    .el-input-group__append {
      background-color: #fff;
      padding: 0;
      margin-left: -1px;
      border-left: none;
      /* EPと同じ上下右ボーダーを維持（box-shadow: none だと消える） */
      box-shadow:
        0 1px 0 0 var(--el-input-border-color, var(--el-border-color)) inset,
        0 -1px 0 0 var(--el-input-border-color, var(--el-border-color)) inset,
        1px 0 0 0 var(--el-input-border-color, var(--el-border-color)) inset;
      transition: box-shadow 0.2s;
    }

    :deep(.el-input-group) {
      display: inline-flex;
    }

    :deep(.el-input__wrapper) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .complete-invoice-input {
    width: 100%;
  }

  .invoice-input-field {
    .el-input__inner {
      font-size: 14px;
    }
  }

  /* フォーカス時: 入力のEP青枠を維持し、アイコンappendにも適用 */
  .invoice-input-with-select .invoice-input-field:focus-within {
    .el-input-group__append {
      box-shadow:
        0 1px 0 0 var(--el-input-focus-border-color, var(--el-color-primary))
          inset,
        0 -1px 0 0 var(--el-input-focus-border-color, var(--el-color-primary))
          inset,
        1px 0 0 0 var(--el-input-focus-border-color, var(--el-color-primary))
          inset !important;
    }
  }
  .invoice-supplier-icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;

    border-left: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    transition:
      border-color 0.2s,
      width 0.15s;
    box-shadow: none;

    &.is-none {
      width: 76px;
    }
  }

  // エラー時: アイコンwrapperとブロック全体のフォーカス
  .el-form-item.is-error {
    .invoice-supplier-icon-wrapper {
      border: 1px solid var(--el-border-color);
      border-left: none;
      border-color: var(--el-color-danger);
    }

    .invoice-input-field:focus-within .el-input-group__append {
      box-shadow:
        0 1px 0 0 var(--el-color-danger) inset,
        0 -1px 0 0 var(--el-color-danger) inset,
        1px 0 0 0 var(--el-color-danger) inset !important;
    }
  }
  .current-supplier-icon {
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 10;
  }
  .invoice-supplier-select-icon {
    width: 100%;
    position: relative;
    z-index: 1;

    :deep(.el-select__wrapper) {
      box-shadow: none !important;
      padding: 0 2px 0 0 !important;
      min-height: 28px;
      background: transparent !important;
      border: none !important;
      gap: 0;
    }

    /* Carrier icons: hide selected label (overlay icon shows instead) */
    :deep(.el-select__selection) {
      opacity: 0;
      width: 0;
      overflow: hidden;
      flex: 0;
    }

    :deep(.el-select__selected-item) {
      display: none;
    }

    :deep(.el-select__placeholder) {
      display: none;
    }

    :deep(.el-select__caret),
    :deep(.el-select__icon) {
      color: #606266;
      font-size: 14px;
      margin: 0 !important;
    }
  }

  /* 設定なし: show short label「なし」from el-option, no overlay */
  .invoice-supplier-icon-wrapper.is-none {
    .invoice-supplier-select-icon {
      :deep(.el-select__wrapper) {
        padding: 0 6px 0 8px !important;
        justify-content: space-between;
        gap: 4px;
      }

      :deep(.el-select__selection) {
        opacity: 1;
        width: auto;
        overflow: visible;
        flex: 1;
        min-width: 0;
        margin-right: 2px;
      }

      :deep(.el-select__selected-item) {
        display: inline-flex;
        font-size: 12px;
        color: #606266;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      :deep(.el-select__placeholder) {
        display: none;
      }

      :deep(.el-select__caret),
      :deep(.el-select__icon) {
        flex-shrink: 0;
        margin-left: 2px !important;
      }
    }
  }
  .select-option-content {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      display: block;
      flex-shrink: 0;
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }
  .complete-supplier-select {
    width: 200px;

    :deep(.el-input__prefix) {
      display: flex;
      align-items: center;
      margin-right: 8px;
    }
  }
  .select-prefix-supplier-icon {
    display: block;
  }
  .invoice-option-logo {
    height: 24px;
    width: 24px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ship-detail-dialog {
    .el-form-item__content {
      text-align: left;
    }
    .el-input {
      width: 150px;
    }
    label {
      font-weight: 600;
    }
    .el-input.is-disabled .el-input__inner {
      color: #606266;
    }
  }
  .complete-dialog {
    .el-dialog {
      margin-left: 220px;
    }
  }
</style>
